[
  {
    "id": "executive-ai-advisory",
    "question": "What is Executive AI Advisory & Solutions?",
    "answer": "Executive AI Advisory & Solutions delivers strategic AI guidance and governance that turns business objectives into actionable, production-ready AI programs. This includes: AI Strategy & Governance (roadmaps, use case prioritization, governance & compliance, vendor oversight); Executive & Board Visibility (dashboards, KPIs, reporting, board-level advisory); and a Dedicated Advisory Model (on-demand executive AI leadership without full-time hires, embedded teams for strategy-to-execution alignment, project-based or retainer engagement).",
    "keywords": ["executive ai advisory", "executive ai advisory & solutions", "ai advisory", "advisory & solutions"]
  },
  {
    "id": "ai-roadmap",
    "question": "What does AI roadmap work include?",
    "answer": "We follow Discovery → Design → Pilot → Production. Discovery identifies high-impact AI opportunities; Design builds roadmaps and governance; Pilot validates in controlled environments; Production scales with clear ownership and ROI. This is delivered through Executive AI Advisory & Solutions and AI Execution & Engineering.",
    "keywords": ["ai roadmap", "roadmap work", "ai strategy", "roadmap", "discovery", "pilot", "production"]
  },
  {
    "id": "execution-engineering",
    "question": "What is AI Execution & Engineering?",
    "answer": "AI Execution & Engineering is embedded AI execution that turns strategy into deployed systems: LLM integration & RAG, custom copilots, ERP/CRM integration, secure data pipelines, and dedicated full-stack AI engineers. Project-based or retainer engagement.",
    "keywords": ["dedicated ai teams", "ai teams", "dedicated team", "execution team", "ai execution", "engineering", "AI Execution & Engineering"]
  },
  {
    "id": "who-for",
    "question": "Who are these services for?",
    "answer": "These services are designed for companies that want to adopt AI but need expert guidance and execution support.",
    "keywords": ["who are these services for", "who is this for", "who is it for", "which companies"]
  },
  {
    "id": "get-started",
    "question": "How do we get started?",
    "answer": "Simply book a short strategy discussion and we’ll explore the best AI approach for your business.",
    "keywords": ["how do we get started", "get started", "start", "next steps"]
  },
  {
    "id": "strategy-discussion",
    "question": "What happens in the strategy discussion?",
    "answer": "We review your goals, identify potential AI opportunities, and suggest the next practical steps.",
    "keywords": ["what happens in the strategy discussion", "strategy discussion", "initial call", "discovery call"]
  },
  {
    "id": "technical-knowledge",
    "question": "Do we need technical knowledge to start?",
    "answer": "No, we guide both technical and non-technical teams through the entire AI adoption process.",
    "keywords": ["need technical knowledge", "technical knowledge", "non-technical", "no technical background"]
  }
]

